var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.getItemClass(),
      attrs: { "drag-value": _vm.info.id },
      on: { click: _vm.onSelect, dblclick: _vm.onDoubleClick },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.edit,
              expression: "!edit",
            },
          ],
          staticClass: "group-item-info",
        },
        [
          _c(
            "div",
            { staticClass: "group-item-info__name" },
            [
              _c(
                "tooltip-content",
                {
                  attrs: {
                    content: _vm.info.groupName,
                    placement: "top-start",
                  },
                },
                [_c("span", [_vm._v(_vm._s(_vm.info.groupName))])]
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              class: {
                "group-item-info__num": true,
                "group-item-info__num--drag": _vm.dragging,
              },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.info.groupMemberList && _vm.info.groupMemberList.length
                )
              ),
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.dragging,
                  expression: "!dragging",
                },
              ],
              staticClass: "group-item-handle",
            },
            [
              _c(
                "yxt-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    effect: "dark",
                    content: _vm.$t("pc_biz_group_rename") /* 重命名 */,
                    placement: "top",
                    "open-delay": 2000,
                    "hide-delay": 0,
                  },
                },
                [
                  _c("span", { staticClass: "group-item-handle__icon" }, [
                    _c("i", {
                      staticClass: "yxt-icon-edit",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.onEdit.apply(null, arguments)
                        },
                      },
                    }),
                  ]),
                ]
              ),
              _c(
                "yxt-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    effect: "dark",
                    content: _vm.$t("pc_biz_group_delete") /* 删除 */,
                    placement: "top",
                    "open-delay": 2000,
                    "hide-delay": 0,
                  },
                },
                [
                  _c("span", { staticClass: "group-item-handle__icon" }, [
                    _c("i", {
                      staticClass: "yxt-icon-delete",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.deleteGroup(_vm.info.id)
                        },
                      },
                    }),
                  ]),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.edit,
              expression: "edit",
            },
          ],
          staticClass: "group-item-info group-item-info--edit",
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _c("yxt-input", {
            ref: "nameRef",
            attrs: { size: "small", maxlength: "20", "show-word-limit": "" },
            on: { blur: _vm.saveGroupName },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.saveGroupName.apply(null, arguments)
              },
            },
            model: {
              value: _vm.currentName,
              callback: function ($$v) {
                _vm.currentName = $$v
              },
              expression: "currentName",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }